<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8Q1xqp/Images/cover.jpeg?1708093843966" alt="This image is the cover for the book Amazing Stories Volume 171, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amazing Stories Volume 171, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Amazing Stories Volume 171 is a great collection of action short stories from "The Golden Age of Science Fiction". Featured here are four short stories by Three different authors: "The Klygha", by H. B. Fyfe, "The Right Side Of The Tracks", and "The Happiness Rock" both by Albert Teichner,  and "A Voice From The Inner World" by A. Hyatt Verrill.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. B. Fyfe
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5091c364